
export function scrollToTop() {
  try {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    })
  } catch (e) {
    // couldn't get scroll info
  }
}

export function triggerInput(fieldId, newValue) {

  const input = document.getElementById(fieldId);
  const lastValue = input.value;
  input.value = newValue;

  const event = new Event("input", { bubbles: true });
  const tracker = input._valueTracker;
  if (tracker) {
    tracker.setValue(lastValue);
  }
  input.dispatchEvent(event);
}

export function isMobile() {
  // TODO: Fix this. It's not detecting mobile phones correctly.
  return window.innerWidth <= 600;
}

export function getGeolocation() {
  const geolocation = sessionStorage.getItem("geolocation")
  const geoSuccess = function (position) {
    if (position) {
      if (position.coords) {
        sessionStorage.setItem('geolocation', JSON.stringify({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }))
      }
    }
  }
  if (!geolocation && navigator.permissions && navigator.permissions.query) {
    navigator.permissions.query({
      name: 'geolocation'
    }).then(permission => {
      if (permission.state !== "denied") {
        navigator.geolocation.getCurrentPosition(geoSuccess)
      }
    }).catch(() => {
      // couldn't query the permission
    });
  }
}
